import getJSON from './get-json';
import {
  BRANCH_API_BASE,
  BRANCH_ORG_ID,
  BRANCH_ELECTION_KEY,
} from '../endpoints';

const COVERED_DISTRICT_TYPES = [
  'state',
  'congressional',
  'state-senate',
  'state-house',
  'state-board-of-education',
];

export function createBallot(location) {
  return getJSON(`${BRANCH_API_BASE}/ballots`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Organization-Id': BRANCH_ORG_ID,
    },
    body: JSON.stringify({
      location,
      election: BRANCH_ELECTION_KEY,
    }),
  });
}

const COUNTY_DISTRICT_TYPES = ['county', 'county-district'];

const isCountyCourtRace = race => {
  const officeName = race.officeName || '';

  return (
    race.district.type === 'county' &&
    /court|judge/i.test(officeName) &&
    !/^county judge$/i.test(officeName.trim())
  );
};

const isCountyEducationRace = race =>
  race.district.type === 'county' && /education/i.test(race.officeName || '');

const isCountyRace = race =>
  COUNTY_DISTRICT_TYPES.includes(race.district.type) &&
  !isCountyCourtRace(race) &&
  !isCountyEducationRace(race);

const CITY_DISTRICT_TYPES = ['city', 'city-council'];

const isCityRace = race => CITY_DISTRICT_TYPES.includes(race.district.type);

const EDUCATION_DISTRICT_TYPES = ['state-school', 'state-school-subdistrict'];

const isEducationRace = race =>
  EDUCATION_DISTRICT_TYPES.includes(race.district.type) ||
  isCountyEducationRace(race);

const isJudicialRace = race =>
  isCountyCourtRace(race) ||
  (!COUNTY_DISTRICT_TYPES.includes(race.district.type) &&
    !isCityRace(race) &&
    !isEducationRace(race));

export const getLocalRaceTitle = race => race.longName || race.officeName;

export const LOCAL_RACE_GROUPS = [
  { key: 'local-county', label: 'Local: County', matches: isCountyRace },
  { key: 'local-city', label: 'Local: City', matches: isCityRace },
  {
    key: 'local-education',
    label: 'Local: Education',
    matches: isEducationRace,
  },
  { key: 'local-judicial', label: 'Local: Judicial', matches: isJudicialRace },
];

export function filterDownBallotRaces(races) {
  if (!races) return [];

  const localRaces = races.filter(race => {
    if (!race.district) return false;
    return !COVERED_DISTRICT_TYPES.includes(race.district.type);
  });

  return [].concat(
    ...LOCAL_RACE_GROUPS.map(group => localRaces.filter(group.matches))
  );
}

export function filterLocalMeasures(measures) {
  if (!measures) return [];

  return measures
    .filter(
      measure =>
        measure.title &&
        measure.district &&
        !COVERED_DISTRICT_TYPES.includes(measure.district.type)
    )
    .sort((a, b) =>
      a.title.localeCompare(b.title, 'en', {
        numeric: true,
        sensitivity: 'base',
      })
    );
}
